export enum PAGE_TYPE {
    TICKETING = 'ticketing',
    REQUESTS = 'requests',
    DASHBOARD = 'dashboard',

}